export const redirectToLead = ({
  leadId,
  $location,
  $state,
}: {
  leadId: string;
  $state: { go(route: string, params: { [key: string]: any }): void };
  $location: angular.ILocationService;
}): void => {
  $state.go(getLeadRouteName({ $location }), { id: leadId });
};

export const getLeadRouteName = ({
  $location,
}: {
  $location: angular.ILocationService;
}): string => {
  if ($location.path().includes('/leads')) {
    return 'leads.leadpopup';
  } else if ($location.path().includes('/appeals')) {
    return 'appeals.leadpopup';
  }

  return 'leadpopup.view';
};
